export default "__VITE_ASSET__BxB$suy___"